module.exports = __webpack_public_path__ + "static/img/demo-group@2x.b46ed7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/demo-group@2x.png
// module id = 564
// module chunks = 1